export default __webpack_public_path__ + "static/Pillars-dark-b7d180bae251fff21b2da4a053e71917.png";